var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArticlePage',{attrs:{"page":"features","content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }